import { createSelector } from '@ngrx/store';

import { getUploadState } from '../../../domain/public-api';
import { getUploaderState } from '../uploader/uploader.state';

export const getFilesState = createSelector(getUploaderState, (state) => state.files);

export const getFileItems = createSelector(getFilesState, (state) => state.files || []);

export const getHasFileItems = createSelector(getFileItems, (fileItems) => fileItems.length > 0);

export const getFileToEdit = createSelector(getFilesState, (state) =>
  state.itemToEdit === undefined
    ? undefined
    : state.files.find((item) => item.id === state.itemToEdit),
);

export const getIsUploadConfirmed = createSelector(
  getFilesState,
  (state) => state.isUploadConfirmed || false,
);

export const getIsUploadComplete = createSelector(getFileItems, (fileItems) =>
  fileItems.every((item) => {
    const upload = getUploadState(item);
    return upload?.uploadStage === 'ENCODED';
  }),
);
